/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */

export const makeInitialNodesAndEdges = (
  nodes: any[] = [],
  edges: any[] = []
) => {
  const formattedNodes: any = [];
  const formattedEdges: any = [];

  const tempNodes = [...(nodes || [])];
  tempNodes?.forEach((node) => {
    if (!node?.icon) {
      node.icon = `https://ui-avatars.com/api/?name=${node.label
        ?.split()
        ?.join('+')}&rounded=true&size=256`;
    }
    formattedNodes.push({
      ...(node || {}),
    });
  });

  const tempEdges = [...(edges || [])];
  tempEdges?.forEach((edge) => {
    if (edge) {
      edge.size = 2;
    }
    formattedEdges.push(edge);
  });

  return {
    formattedNodes: formattedNodes,
    formattedEdges: formattedEdges,
  };
};
